export default function (suffix) {
  const baseApiUrl = process.env.REACT_APP_BASE_API_URL || "/analytics/api/";
  return `${baseApiUrl}dataservice/statistics/${suffix}`;
}
